import { render, staticRenderFns } from "./LoadRecent.vue?vue&type=template&id=089d56dc&lang=pug"
import script from "./LoadRecent.vue?vue&type=script&lang=js"
export * from "./LoadRecent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports